import { render, staticRenderFns } from "./ResponseHistory.vue?vue&type=template&id=56f633f4&"
import script from "./ResponseHistory.vue?vue&type=script&lang=js&"
export * from "./ResponseHistory.vue?vue&type=script&lang=js&"
import style0 from "./ResponseHistory.vue?vue&type=style&index=0&id=56f633f4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports